import { useMutation } from '@hooks/reactQuery';

import { checkAcquirePolygonAsset } from '@api/assets';

import { IAcquirePolygonAssetDTO } from '@interfaces/map/dto/polygonDTO';

import { ACQUIRE_ASSET } from '@constants/queryKeys';

export const useMutateCheckAcquirePolygonAsset = (onSettledCallback: (data: number) => void) => {
	const {
		mutate: handleCheckAddToCartPolygon,
		isLoading: isCheckingAddToCartPolygon,
	} = useMutation<IAcquirePolygonAssetDTO>({
		mutationKey: [ACQUIRE_ASSET],
		mutationFn: checkAcquirePolygonAsset,
		onSuccess: (data: number) => {
			onSettledCallback(data);
		},
	});

	return {
		handleCheckAddToCartPolygon,
		isCheckingAddToCartPolygon,
	};
};
